// @ts-nocheck
const setIntervalWorker = () => {
setInterval(() => {
    postMessage("check token");
}, 60000);
}

let code = setIntervalWorker.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const worker_script = URL.createObjectURL(blob);

export default worker_script;